import { User } from '@xver/@types/user';
import httpClient from '@xver/libs/axios';

import {
    SendChangePhoneRequestModel,
    SendChangePhoneResponseModel,
    UpdateMeRequestModel,
    UpdateMeResponseModel,
    VerifyChangePhoneRequestModel,
    VerifyChangePhoneResponseModel,
} from './model';

const ENDPOINTS = {
    GET_ME: '/v1/users/me',
    UPDATE_ME: '/v1/users/me',
    SEND_CHANGE_PHONE: '/v1/users/me/send-change-phone',
    VERIFY_CHANGE_PHONE: '/v1/users/me/verify-change-phone',
};

export function getMe(): Promise<User> {
    return httpClient.get(ENDPOINTS.GET_ME);
}

export function updateMe(payload: UpdateMeRequestModel): Promise<UpdateMeResponseModel> {
    return httpClient.put(ENDPOINTS.UPDATE_ME, payload);
}

export function sendChangePhone(
    payload: SendChangePhoneRequestModel
): Promise<SendChangePhoneResponseModel> {
    return httpClient.post(ENDPOINTS.SEND_CHANGE_PHONE, payload);
}

export function verifyChangePhone(
    payload: VerifyChangePhoneRequestModel
): Promise<VerifyChangePhoneResponseModel> {
    return httpClient.post(ENDPOINTS.VERIFY_CHANGE_PHONE, payload);
}
